var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-content-header", { attrs: { item: _vm.item } }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "content-section" },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("page-content-creator", {
                        attrs: { itemid: _vm.itemid, pos: "top" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _vm.itemid
                        ? _c("node-element-local-tasks", {
                            attrs: { itemid: _vm.itemid },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.notpublished
                        ? _c("div", { staticClass: "messages warning" }, [
                            _vm._v("Not published"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _vm.hasBody
                        ? _c("page-content-wysiwg-content", {
                            attrs: { item: _vm.item },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.drupalmode
                        ? _c("div", {
                            staticClass: "attached-view",
                            domProps: { innerHTML: _vm._s(_vm.attachedView) },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.icmsmode
                        ? _c(
                            "div",
                            { staticClass: "attached-view" },
                            [
                              _vm._l(_vm.listItems, function (listItem, key) {
                                return [
                                  _c(_vm.itemComponent, {
                                    key: key,
                                    tag: "component",
                                    attrs: { item: listItem },
                                  }),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("page-content-creator", {
            attrs: { itemid: _vm.itemid, pos: "bottom" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }